export default __webpack_public_path__ + "static/media/why2.ad6c5c6e.svg";